import { useContext } from 'react';
import { GroupEntityTagsContext } from '@trinity/chat-components/contexts/group-tags/index.js';

export default function useGroupEntityTags() {
  const value = useContext(GroupEntityTagsContext);
  return value;
}

export { useGroupEntityTags };